import * as yup from 'yup'
// import { fullWidthRegExp } from 'Utils/utils'

// eslint-disable-next-line no-unused-vars
export function createPortFolioValidation(t) {
  return yup.object().shape({
    clientName: yup
      .string()
      .required()
      .trim()
      .min(1)
  })
}

export function updateNamePortFolioValidation(t) {
  return yup.object().shape({
    name: yup
      .string()
      .required()
      .trim()
      .max(255, t('error_message:MAX_LEN_255'))
  })
}
